// import { Courier_Prime } from "next/font/google";
import localFont from "next/font/local";

// For testing
// export const RemiFontSuisseIntl = Courier_Prime({
//   variable: "--font-suisse-intl",
//   weight: "400",
//   display: "swap",
//   subsets: ["latin"],
// });

const remiPrimaryFont = localFont({
  variable: "--font-primary",
  src: [
    {
      path: "./suisse-intl/SuisseIntl-Regular.otf",
      weight: "400",
      style: "normal",
    },
    {
      path: "./suisse-intl/SuisseIntl-RegularItalic.otf",
      weight: "400",
      style: "italic",
    },
    {
      path: "./suisse-intl/SuisseIntl-Book.otf",
      weight: "450",
      style: "normal",
    },
    {
      path: "./suisse-intl/SuisseIntl-BookItalic.otf",
      weight: "450",
      style: "italic",
    },
    {
      path: "./suisse-intl/SuisseIntl-Medium.otf",
      weight: "500",
      style: "normal",
    },
    {
      path: "./suisse-intl/SuisseIntl-MediumItalic.otf",
      weight: "500",
      style: "italic",
    },
    {
      path: "./suisse-intl/SuisseIntl-SemiBold.otf",
      weight: "600",
      style: "normal",
    },
    {
      path: "./suisse-intl/SuisseIntl-SemiBoldItalic.otf",
      weight: "600",
      style: "italic",
    },
  ],
  display: "swap",
});

export const RemiFontPrimary = remiPrimaryFont;
